import React, { useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import theme from './styles/themes/theme';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { NonceProvider } from './context/NonceContext';
import { AuthProvider } from './context/AuthContext';
import { Loader } from '@googlemaps/js-api-loader';
import 'react-phone-input-2/lib/style.css';
import App from './App';
import './App.css';
import { installNetworkBridge } from './bootstrap/networkBridge';

installNetworkBridge();

// Crea la cache de Emotion con el nonce
const emotionCache = createCache({
  key: 'css',
  prepend: true
});

// Carga Google Maps API usando @googlemaps/js-api-loader (recomendado por Google)
function GoogleMapsLoader({ children }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (window.google && window.google.maps) {
      setLoaded(true);
      return;
    }
    const loader = new Loader({
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
      libraries: ['places'],
    });
    loader.load().then(() => setLoaded(true));
  }, []);

  if (!loaded) return null;
  return children;
}


// Renderiza la aplicación combinando ambos providers
const root = createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <CacheProvider value={emotionCache}>
      <ChakraProvider theme={theme} emotionCache={emotionCache}>
        <NonceProvider>
          <GoogleMapsLoader>
            <AuthProvider>
                <App />
            </AuthProvider>
          </GoogleMapsLoader>
        </NonceProvider>
      </ChakraProvider>
    </CacheProvider>
  </React.StrictMode>
);
